import { render, staticRenderFns } from "./RatingValueStar.vue?vue&type=template&id=2763e243&"
import script from "./RatingValueStar.vue?vue&type=script&lang=ts&"
export * from "./RatingValueStar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports